import { isNativeIos } from './device';
import { APP_STORE_SWIBECO, GOOGLE_PLAY_SWIBECO } from '../router';

export const getAppStoreLink = (window: Record<string, any>) =>
  !isNativeIos(window) ? GOOGLE_PLAY_SWIBECO : APP_STORE_SWIBECO;
